import { indexData } from '@/mocks/comics';

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  accent: { bg: 'bg-accent-50', text: 'text-accent-600', border: 'border-accent-100 hover:border-accent-300' },
  primary: { bg: 'bg-primary-50', text: 'text-primary-600', border: 'border-primary-100 hover:border-primary-300' },
  secondary: { bg: 'bg-secondary-50', text: 'text-secondary-600', border: 'border-secondary-100 hover:border-secondary-300' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            分类索引
          </h2>
          <p className="text-sm text-foreground-500">
            按国家和类型快速找到你想看的漫画
          </p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-3 md:gap-4">
          {indexData.map((item) => {
            const colors = colorMap[item.color];
            return (
              <a
                key={item.id}
                href="#index"
                className={`flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl border ${colors.border} bg-background-50 transition-all cursor-pointer group`}
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${colors.bg} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                  <i className={`${item.icon} ${colors.text} text-xl md:text-2xl`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.name}</span>
                <span className="text-xs text-foreground-500">{item.count.toLocaleString()}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}